
import { useLayoutEffect, useState } from "react";

// Devuelve width y height del ref
export function useRefSize(ref) {
    const [size, setSize] = useState({ width: 0, height: 0 });

    useLayoutEffect(() => {
        const element = ref?.current;
        if (!element) return;

        const observer = new ResizeObserver(([entry]) => {
            const { width, height } = entry.contentRect;
            setSize({ width, height });
        });

        observer.observe(element);

        // Initialize size immediately
        setSize({
            width: element.offsetWidth,
            height: element.offsetHeight,
        });

        return () => {
            observer.disconnect();
        };
    }, [ref]);
    return [size.width, size.height];
}
